import $ from 'jquery';
import Websockets from 'lib/websockets';
import config from 'lib/config';

const W = window;
const $W = $(W);
const $D = $(document);

const COMMAND_SCANNER = `
  mutation commandScanner($input: ScannerCommandInput!) {
    result: commandScanner(input: $input) {
      data
    }
  }
`;

const sendCommand = async input =>
  $.GraphQL.runQuery(COMMAND_SCANNER, {
    operationName: 'commandScanner',
    variables: {
      input,
    },
  });

$.onAuth(async ({ authenticated, website, user }) => {
  if (authenticated && $.hasPerms('scanner')) {
    const $body = $('body');
    const $btn = $('.btn-scanner');
    const $popover = $('#scanners-popover');
    let scanner;
    let timeout;
    let promise;

    const sendKeepalive = async () => {
      if (scanner && Websockets.isConnected()) {
        console.log('🖨 SCANNER:KEEPALIVE');

        await sendCommand({
          type: 'capture',
          id: scanner.id,
        });
      }

      timeout = setTimeout(sendKeepalive, config.scanner.user.keepalive * 1000);
    };

    $btn
      .on('show.bs.popover', async evt => {
        const loaded = $btn.data('loaded');

        if (loaded !== true) {
          evt.preventDefault();

          const { result } = await sendCommand({
            type: 'list',
            id: 0,
          });

          const available = result.data.filter(s => !s.user || s.user.id !== user.id);
          const current = scanner && scanner.id ? result.data.find(s => s.id === scanner.id) : null;

          $popover.render('scanners_popover', current, available);
          $btn.data('loaded', true).popover('show');
        }
      })

      .on('shown.bs.popover', () => {
        $btn.data('loaded', false);
      });

    $popover
      .on('click', '.btn-capture', async evt => {
        const $obj = $(evt.target).closest('.list-group-item');
        const id = $obj.data('id');
        const user_id = $obj.data('user-id');

        if (user_id && user_id !== user.id) {
          const result = await $.confirm('The chosen scanner is already being used by another user. Are you sure you would like to continue?', 'Connect to Scanner');
          if (!result) return;
        }

        $btn.popover('hide');

        await sendCommand({
          type: 'capture',
          id,
        });
      })

      .on('click', '.btn-release', async evt => {
        $btn.popover('hide');

        await sendCommand({
          type: 'release',
          id: scanner.id,
        });
      });

    $D.on('websocket:opened', async () => {
      let id = $.globalStorage.get('scanner');

      if (!id) $btn.find('.badge').removeClass('badge-success').addClass('badge-danger');
      else
        await sendCommand({
          type: 'capture',
          id,
        });

      sendKeepalive();
    });

    $D.on('websocket:closed', async () => {
      clearTimeout(timeout);
      $body.removeClass('use-scanner');
      $btn.find('.badge').removeClass('badge-success').addClass('badge-danger');
      $W.trigger('scanner:change', [false]);
    });

    $.subscribe({ type: 'discrete', name: `scanner:${user.id}` }, (channel, payload) => {
      const { type, id, name } = payload;

      switch (type) {
        case 'released': {
          if (scanner) {
            console.groupCollapsed('🖨 SCANNER:RELEASED');
            console.log('ID', scanner.id);
            console.log('NAME', scanner.name);
            console.groupEnd();
          }

          scanner = null;
          $.globalStorage.remove('scanner');
          $body.removeClass('use-scanner');
          $btn.find('.badge').removeClass('badge-success').addClass('badge-danger');
          $W.trigger('scanner:change', [false]);
          break;
        }

        case 'captured': {
          if (!scanner || scanner.id !== id) {
            console.groupCollapsed('🖨 SCANNER:CAPTURED');
            console.log('ID', id);
            console.log('NAME', name);
            console.groupEnd();
          }

          scanner = { id, name };
          $.globalStorage.set('scanner', scanner.id);
          $body.addClass('use-scanner');
          $btn.find('.badge').removeClass('badge-danger').addClass('badge-success');
          $W.trigger('scanner:change', [true]);
          break;
        }

        case 'result': {
          if (!promise) return;

          if (payload.error) promise.reject(payload.error);
          else promise.resolve(payload.file);

          break;
        }
      }
    });

    $D.on('click', '.scanner .btn-cancel', async evt => {
      await sendCommand({
        type: 'cancel',
        id: scanner.id,
      });
    });

    $D.on('click', '[data-scanner]', async evt => {
      if (!scanner) return;

      const $obj = $(evt.target).closest('[data-scanner]');
      const payload = $obj.data('payload');

      try {
        const file = await $.scanner(payload);

        $obj.trigger('scanner:scan', [file]);
      } catch (err) {
        $.toastr({ type: 'error', message: err });
      }
    });

    $.scanner = async payload => {
      return new Promise(async (resolve, reject) => {
        promise = { resolve, reject };

        const $scanner = $('<div class="scanner fade"><h1>Waiting for<br/>scanner</h1><a class="btn btn-warning btn-cancel">Cancel</a></div>').appendTo($body);

        await sendCommand({
          type: 'scan',
          id: scanner.id,
          payload,
        });

        setTimeout(() => {
          $scanner.addClass('show');
        }, 0);
      }).finally(() => {
        promise = null;

        const $scanner = $body.find('.scanner');

        if ($scanner.length) {
          $scanner
            .one('transitionend', () => {
              $scanner.remove();
            })
            .removeClass('show');
        }
      });
    };
  }
});
